"use strict";

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var DefaultEngine = require('../lib/comunica-engine');
/**
 * Asynchronous iterator wrapper for the Comunica SPARQL query engine.
 */


var ComunicaEngine =
/*#__PURE__*/
function () {
  /**
   * Create a ComunicaEngine to query the given default source.
   *
   * The default source can be a single URL, an RDF/JS Datasource,
   * or an array with any of these.
   */
  function ComunicaEngine(defaultSource) {
    _classCallCheck(this, ComunicaEngine);

    this._engine = DefaultEngine;
    this._sources = this.toComunicaSources(defaultSource);
  }
  /**
   * Creates an asynchronous iterable of results for the given SPARQL query.
   */


  _createClass(ComunicaEngine, [{
    key: "execute",
    value: function execute(sparql, source) {
      var _this = this;

      // Comunica does not support SPARQL UPDATE queries yet,
      // so we temporarily throw an error for them.
      if (sparql.startsWith('INSERT') || sparql.startsWith('DELETE')) return this.executeUpdate(sparql, source); // Create an iterator function that reads the next binding

      var bindings;
      var errors = [];

      var next =
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var sources, queryResult;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (bindings) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 3;
                  return source ? _this.toComunicaSources(source) : _this._sources;

                case 3:
                  sources = _context.sent;
                  _context.next = 6;
                  return _this._engine.query(sparql, {
                    sources: sources
                  });

                case 6:
                  queryResult = _context.sent;
                  bindings = queryResult.bindingsStream;
                  bindings.on('error', function (error) {
                    return errors.push(error);
                  });

                case 9:
                  return _context.abrupt("return", new Promise(readNextBinding));

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function next() {
          return _ref.apply(this, arguments);
        };
      }();

      return _defineProperty({
        next: next
      }, Symbol.asyncIterator, function () {
        return this;
      }); // Reads the next binding

      function readNextBinding(resolve, reject) {
        if (errors.length > 0) return reject(errors.shift()); // Mark the iterator as done when the source has ended

        var done = function done() {
          return resolve({
            done: true
          });
        };

        if (bindings.ended) {
          done();
        } else {
          // Wait for either the data or the end event
          bindings.once('data', function (data) {
            resolve({
              value: data
            });
            bindings.removeListener('end', done);
          });
          bindings.on('end', done);
        }
      }
    }
    /**
     * Creates an asynchronous iterable with the results of the SPARQL UPDATE query.
     */

  }, {
    key: "executeUpdate",
    value: function executeUpdate(sparql, source) {
      throw new Error("Comunica does not support SPARQL UPDATE queries, received: ".concat(sparql));
    }
    /**
     * Parses the source(s) into an array of Comunica sources.
     */

  }, {
    key: "toComunicaSources",
    value: function () {
      var _toComunicaSources = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(source) {
        var sources;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return source;

              case 2:
                sources = _context2.sent;

                if (sources) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", null);

              case 5:
                // Strip the fragment of a URI
                if (sources instanceof URL) sources = sources.href;else if (sources.termType === 'NamedNode') sources = sources.value;

                if (!(typeof sources === 'string')) {
                  _context2.next = 10;
                  break;
                }

                sources = [sources.replace(/#.*/, '')]; // Await multiple promises in an array

                _context2.next = 17;
                break;

              case 10:
                if (!Array.isArray(sources)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 13;
                return Promise.all(sources);

              case 13:
                sources = _context2.sent;
                _context2.next = 17;
                break;

              case 16:
                // Wrap a single source in an array
                sources = [sources];

              case 17:
                return _context2.abrupt("return", sources.map(function (value) {
                  return {
                    value: value,
                    type: typeof value === 'string' ? 'file' : 'rdfjsSource'
                  };
                }));

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function toComunicaSources(_x) {
        return _toComunicaSources.apply(this, arguments);
      }

      return toComunicaSources;
    }()
  }]);

  return ComunicaEngine;
}();

exports.default = ComunicaEngine;